
import React, {Fragment} from 'react';
import {useEffect, useState} from "react";
import {getSchool360SchoolsByLea} from '../../DataFunctions/SchoolDataFns';
import SpinnerDiv from "../../Forms/UI/SpinnerDiv";
import TanStackTable from "../../TanstackTables/TanStackTable";
import './SchoolsTable.scss';
import useModalEnableSchoolGDPR from "../Modals/EnableSchoolGDPR/useModalEnableSchoolGDPR";
import IconTooltip from "../../ui/Tooltip/IconTooltip";
import {customHeaderStyle, defaultTableHeaderStyles, defaultTopRightCellStyle} from "../../Tables/BaseTableComponents";

const EMPTY_DATA = {data: [], isLoading: false};

const DROPDOWN_MARGIN_THRESHOLD = 2;

const SchoolsTable = ({leaDetails, school_id, user_type, filter, menu, page, setShowDropdownMargin}) =>
{

    const [data, setData] = useState(EMPTY_DATA);


    const getData = (lea_id) =>
    {
        setData({data: [], isLoading: true});

        getSchool360SchoolsByLea(lea_id, (resp) =>
        {
            setData({data: resp.results.record_set, isLoading: false})
            if (resp.results.record_set.length <= DROPDOWN_MARGIN_THRESHOLD)
            {
                setShowDropdownMargin(true);
            }
        });
    }

    const [renderGDPRModal, activateGDPRModal] = useModalEnableSchoolGDPR(() => getData(leaDetails.lea_id));


    useEffect(() =>
    {
        getData(leaDetails.lea_id);
    },[leaDetails])

    //Info is the data from the column as passed into the table via data.data (info.row.original = data.data - in this instance)
    const schoolRowFormatter = (info) =>
    {
        const row = info.row.original;

        const str = row.school_name;

        return <div>{str}</div>
    }

    const actionFormatter = (info) =>
    {
        const row = info.row.original;

        const school_row_id = row.school_id
        const school_name = row.school_name;
        const gdpr_flag = row.gdpr_enabled;

        const GDPR_color = +gdpr_flag === 0 ? '#d1d2d2' : "#5435AF";

        const GDPR_instruction = +gdpr_flag === 0 ? "Enable" : "Disable";

        const link = "/eyfs_admin.php?lang=en&page=EYFSSchoolAdmin_n&school_id=" + school_row_id + "&mode=edit&menu=2&return=cGFnZT1zY2hvb2xzX24mbWVudT0yJnVzZXJfdHlwZT00JmZpbHRlcj00";

        return <div className="action-buttons">
            <a href={link}><IconTooltip icon='glyphicon-pencil' text="Edit"/></a>
            <div style={{fontSize:'18px'}}><IconTooltip onClick={() => activateGDPRModal(school_row_id, school_name, gdpr_flag)} placement='top' text={GDPR_instruction + " GDPR"} icon="fa-shield" color={GDPR_color}/></div>
        </div>
    }

    //Accessor key is the name of the key for the data passed into the table component e.g. data.data.school_name
    const columns = [
        {accessorKey: 'school_name', header: 'School Name', cell: schoolRowFormatter},
        {accessorKey: 'email', header: 'Email', enableSorting: true},
        {accessorKey: 'phone', header: 'Phone', enableSorting: false},
        {
            accessorKey: 'actions',
            header: 'Options',
            enableSorting: false,
            meta: {textAlign: 'center'},
            cell: actionFormatter
        }
    ];


    //return data.isLoading ? <div style={{marginTop: "20px"}}><SpinnerDiv/></div> : data.data.length === 0 ? <div className='no-records'>No matching records found</div> : <TanStackTable data={data.data as any} columns={columns as any} showSearch={true}/>


    if (data.isLoading === true)
    {
        return <div style={{marginTop: "20px"}}><SpinnerDiv/></div>
    }
    else
    {
        return (
            <div className='school-table-div'>
                {data.data.length === 0 ? <div className='no-records'>No matching records found</div> : <TanStackTable data={data.data as any} columns={columns as any} showSearch={true}/>}
                {renderGDPRModal()}
            </div>
        )
    }

}


export default SchoolsTable;